module.exports = __webpack_public_path__ + "static/media/listImage.ec20ce6e.png";